import { Component, HostListener, inject, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { WhatsappButtonComponent } from './components/shared/whatsapp-button/whatsapp-button.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ToastModule } from 'primeng/toast';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { filter, Observable, Subscription } from 'rxjs';
import { User } from './components/Theme/store/Authentication/auth.models';
import { AccountService } from './services/account.service';
import { SnackbarService } from './services/snackbar.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    WhatsappButtonComponent,
    NgxUiLoaderModule,
    ToastModule,
    MatIconModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Dalel Plus';
  applied_lang = null;
  cart_quantity = 0;
  currentUser: User = null;
  showBackToTop = false;
  showHeader = true;
  showFooter = true;
  showWhatsapp = true;

  private store = inject(Store)
  showMiniProduct$: Observable<boolean>;
  private routerSub?: Subscription;

  constructor(
    private AccountService: AccountService,
    private loader: NgxUiLoaderService,
    private snackbar: SnackbarService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.updateChromeFlag(this.router.url);
    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.updateChromeFlag(e.urlAfterRedirects || e.url));
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  private updateChromeFlag(url: string): void {
    const path = (url || '').split('?')[0];
    const isHome = path === '/home' || path.startsWith('/home/');
    const isAuth = path === '/auth' || path.startsWith('/auth/');
    // Sticky navbar on all pages including login/register
    this.showHeader = true;
    // Home keeps its own footer / floating whatsapp
    this.showFooter = !isAuth && !isHome;
    this.showWhatsapp = !isAuth && !isHome;
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.showBackToTop = window.scrollY > 320;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getUser() {
    // start loading
    this.loader.start('10002');

    // send the request
    this.AccountService.getUserData().subscribe(res => {
      // stop loading
      this.loader.stop('10002');

      this.currentUser = <User> res['data']['user'];
      this.AccountService.setSharedUser(this.currentUser);

    }, (e) => {
      // stop loading — guest session is expected
      this.loader.stop('10002');
      this.AccountService.setSharedUser(null);
      this.currentUser = null;
    })
  }
}
